<template>
    <div class="center_department_box">
        <!-- 标题 -->
        <center-title>{{$t("message.cdepartment.title")}}</center-title>
        <!-- 表格 -->
        <department-table
            v-model="search"
            :prop-attr="sortAttr"
            :order="sortMode"
            :current-page="page.current_page"
            :page-count="page.last_page"
            @handleSearch="handleSearch"
            @selection-change="handleSelectionChange"
            @handleSort="handleSort"
            @current-change="handleCurrent"
            @handleModify="getDepartmentDetail"
            @handleDelete="handleDel"
            @batch-del="handleBatchDel">
        </department-table>
        <!-- 模态框 -->
        <department-dialog
            @handleModify="handleModify"
            @handleClose="handleCloseDialog">
            <template #form>
                <department-form
                    ref="editForm"
                    :key="editForm"
                    :department-detail="department_detail">
                </department-form>
            </template>
        </department-dialog>
        <!-- 添加 -->
        <department-add>
            <template #addForm>
                <department-form :key="addForm">
                    <template #submit="{ form, rule }">
                        <el-button
                            type="primary"
                            @click="handleSubmit(form, rule)">
                            <span>{{$t("public.submitBtn")}}</span>
                        </el-button>
                    </template>
                </department-form>
            </template>
        </department-add>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { tableRouterView } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableRouterView ],
    computed: mapState({
        power: state => state.user.power,
        user_info: state => state.user.user_info,
        department_detail: state => state.user.department_detail,
        page: state => state.user.page
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        departmentTable: () => import("@/components/center/departmentTable"),
        departmentDialog: () => import("@/components/center/departmentDialog"),
        departmentAdd: () => import("@/components/center/departmentAdd"),
        departmentForm: () => import("@/components/center/departmentForm")
    },
    methods: {
        ...mapMutations([
            "setBalance",
            'setPage',
            'setDepartmentList',
            'setDepartmentDetail',
            'handleDialog'
        ]),
        ...mapActions([
            "getDepartmentList",
            "getDepartmentParent",
            "getBranchBalance",
            'getDepartmentDetail',
            'handleAddDepartment',
            'handleDelDepartment'
        ]),
        // 查
        getDepartmentData(search, attr, mode, page = 1) {
            let branch_id = this.user_info.branch_id || 0;
            this.getBranchBalance(branch_id);
            this.getDepartmentList({
                search,
                attr,
                mode,
                page
            });
            this.getDepartmentParent();
        },
        changeRouter(search, attr, mode, page = 1) {
            this.$router.push({
                name: 'department',
                query: {
                    search,
                    attr,
                    mode,
                    page
                }
            }).catch(err => err)
        },
        // 删
        handleDel(res) {
            if(res){
                this.$message({
                    showClose: true,
                    message: this.$t("public.delSucc"),
                    type: "success"
                })
                setTimeout(() => {
                    this.getDepartmentData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
                },1000)
            }else{
                // delete Address fail and do something
            }
        },
        handleBatchDel() {
            this.$confirm(this.$t("message.cdepartment.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => {
                let list = this.selectedList.map(element => {
                    return element.department_id
                });
				if(list.length==0){
					this.$message({
						showClose: true,
						message: '請選擇刪除部門',
						type: "error"
					})
					return
				}
                let id = list.join();
                return this.handleDelDepartment(id)
            }).then((res) => {
                this.handleDel(res)
            }).catch(() => {})
        },
        // 增
        handleSubmit(form, rule) {
            let r1 = rule.rule1.validate(),
                r2 = rule.rule2.validate(),
                r3 = rule.rule3.validate(),
                r4 = rule.rule4.validate();
            
            Promise.all(
                [r1, r2, r3, r4]
            ).then(
                this.handleAddDepartment({
                    branch_id: form.branch_id,
                    department_code: form.department_code,
                    departmentname: form.cn_name,
                    en_departmentname: form.en_name,
                    email: form.email,
                    principal: form.principal,
                    phone: form.phone,
                    amount: form.amount
                })
            ).then(res => {
                if(res){
                    this.addForm = this.addForm == 0? 1: 0;
                    this.$message({
                        showClose: true,
                        message: this.$t("public.addSucc"),
                        type: "success"
                    })
                    setTimeout(() => {
                        this.getDepartmentData(this.search, this.sortAttr, this.sortMode, this.$route.query.page)
                    },1000)
                }else{
                    // add Address fail and do something
                }
            }).catch(err => console.log('err=',err))
        },
        // 改
        handleCloseDialog() {
            this.handleDialog(false);
            this.setDepartmentDetail({});
            this.getDepartmentData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
        },
        handleModify(handleClose) {
            let form = this.$refs.editForm.form, 
            rule = this.$refs.editForm.$refs;

            let r1 = rule.rule1.validate(),
                r2 = rule.rule2.validate(),
                r3 = rule.rule3.validate(),
                r4 = rule.rule4.validate();
            
            Promise.all(
                [r1, r2, r3, r4]
            ).then(
                this.handleAddDepartment({
                    department_id: this.department_detail.department_id,
                    branch_id: form.branch_id,
                    department_code: form.department_code,
                    departmentname: form.cn_name,
                    en_departmentname: form.en_name,
                    email: form.email,
                    principal: form.principal,
                    phone: form.phone,
                    amount: form.amount,
                    url: "/index/department/editpost"
                })
            ).then(res => {
                if(res){
                    handleClose();
                    this.editForm = this.editForm == 0? 1: 0;
                    this.$message({
                        showClose: true,
                        message: this.$t("public.modifySucc"),
                        type: "success"
                    })
                }else{
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cbranch.errmsg"),
                        type: "error"
                    })
                }
            }).catch(err => console.log('err=',err))
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(2);
				
				let {
				    search = '',
				    attr = '',
				    mode = '',
				    page = 1
				} = to.query;
				
				if(!allow){
				    vm.$router.back();
				    return false;
				}
				vm.getDepartmentData(search, attr, mode, page);
			}, 500)
        })
    },
    beforeRouteUpdate (to, from, next) {
        let {
            search,
            attr,
            mode,
            page
        } = to.query;

        this.getDepartmentData(search, attr, mode, page);
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setBalance(0);
        this.setDepartmentList([]);
        this.setPage({});
        next();
    }
}
</script>